import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  static targets = ['field', 'button']
  static values = { lang: String }

  connect() {
    this.makeButtonActive()
    this.translatableSelector = document.getElementById('translatable_locale')
    if (!this.translatableSelector) {
      return
    }
    this.selectizeInstance = this.translatableSelector.selectize
    this.handleLangChange()
    this.initializeTranslatableLocale()
  }

  initializeTranslatableLocale(){
    const firstOptionValue = this.selectizeInstance.options[Object.keys(this.selectizeInstance.options)[0]].value
    this.selectizeInstance.setValue(firstOptionValue)
  }

  handleLangChange() {
    this.selectizeInstance.on('change', (value) => {
      console.log(value)
      if (value == "") {
        return
      }
      this.showFields(value)
    })
  }

  showFields(lang) {
    this.fieldTargets.forEach(element => {
      if (element.dataset.lang == lang) {
        element.classList.remove('hidden')
      } else {
        if (!element.classList.contains('hidden')) {
          element.classList.add('hidden')
        }
      }
    });
  }


  makeButtonActive() {
    this.buttonTargets.forEach(buttonTarget => {
      if (buttonTarget.dataset.lang == this.langValue)
        buttonTarget.classList.add('active')
      else
        buttonTarget.classList.remove('active')
    })
  }
}
